export default{dataTable:"w_GQ"};
